module.exports = __webpack_public_path__ + "img/grondeigendom-rood.8ca79bf0.png";